import { createFileRoute, Outlet } from '@tanstack/react-router'
import { UserWidget } from '@/widgets/user-widget'

export const Route = createFileRoute('/_auth/users/apk/list')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <UserWidget />
      <Outlet />
    </>
  )
}
